// extracted by mini-css-extract-plugin
module.exports = {"reportIframe":"SrMetabaseCharts--reportIframe--8dg4I","highlightYellowFadeIn":"SrMetabaseCharts--highlightYellowFadeIn--1DCkd"};